import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[autoFocus]',
  standalone: true,
})
export class AutoFocusDirective implements OnChanges {
  @Input() autoFocus = false;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnChanges() {
    if (!this.autoFocus) return;

    setTimeout(() => {
      const el = this.el.nativeElement;
      if (el.offsetParent !== null && !(el as any).disabled) {
        el.focus();
      }
    });
  }
}
